module.exports = __webpack_public_path__ + "static/media/pool80percent.c99d71db.jpg";